import React from 'react';
import {DropdownContextProps, DropdownContext} from '../utils/DropdownContext';

export const useDropdownContext = (currentComponent: string): DropdownContextProps => {
    const context = React.useContext(DropdownContext);

    if (context === undefined) {
        throw Error(
            `Dropdown ${currentComponent} must be used inside of a Dropdown, ` +
            'otherwise it will not function correctly.'
        );
    }

    return context;
};
